import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { StyledTagContainer, StyledTagsWrapper, StyledTag, ChevronIcon, EllipsisIcon } from './Tag.style';
export const Tag = ({ className, type, mainTag, tags, id }) => {
    var _a;
    const [showAllTags, setShowAllTags] = useState(false);
    const [hasOverflow, setHasOverflow] = useState(false);
    const [visibleTags, setVisibleTags] = useState([]);
    const containerRef = useRef(null);
    const tagsRef = useRef(null);
    useEffect(() => {
        if (type === 'action' && tags) {
            const checkOverflow = () => {
                if (tagsRef.current && !showAllTags) {
                    setVisibleTags(tags);
                    setHasOverflow(false);
                    if (tagsRef.current && containerRef.current) {
                        const containerWidth = containerRef.current.offsetWidth;
                        const maxHeight = window.innerWidth >= 768 ? 44 : 88;
                        const hasHeightOverflow = tagsRef.current.scrollHeight > maxHeight;
                        const hasWidthOverflow = tagsRef.current.scrollWidth > containerWidth;
                        if (hasHeightOverflow || hasWidthOverflow) {
                            const tagElements = Array.from(tagsRef.current.children);
                            let visibleCount = 0;
                            for (let i = 0; i < tagElements.length; i++) {
                                const tagRect = tagElements[i].getBoundingClientRect();
                                const containerRect = tagsRef.current.getBoundingClientRect();
                                const tagBottom = tagRect.bottom - containerRect.top;
                                if (tagBottom <= maxHeight) {
                                    visibleCount = i + 1;
                                }
                                else {
                                    break;
                                }
                            }
                            if (visibleCount > 0 && visibleCount < tags.length) {
                                visibleCount = Math.max(1, visibleCount - 1);
                                setVisibleTags(tags.slice(0, visibleCount));
                                setHasOverflow(true);
                            }
                            else if (visibleCount === tags.length) {
                                setVisibleTags(tags);
                                setHasOverflow(false);
                            }
                            else {
                                setVisibleTags(tags.slice(0, 1));
                                setHasOverflow(tags.length > 1);
                            }
                        }
                        else {
                            setVisibleTags(tags);
                            setHasOverflow(false);
                        }
                    }
                }
                else if (showAllTags) {
                    setVisibleTags(tags);
                    setHasOverflow(false);
                }
            };
            const observer = new ResizeObserver(() => {
                requestAnimationFrame(checkOverflow);
            });
            if (containerRef.current)
                observer.observe(containerRef.current);
            return () => observer.disconnect();
        }
    }, [tags, type, showAllTags]);
    if (type === 'decorative') {
        return (_jsx(StyledTag, { variant: "decorative", className: className !== null && className !== void 0 ? className : '', as: "div", children: mainTag !== null && mainTag !== void 0 ? mainTag : '' }));
    }
    return (_jsx(StyledTagContainer, { className: 'ps-atoms-tag ' + className, ref: containerRef, children: _jsxs(StyledTagsWrapper, { showAll: showAllTags, ref: tagsRef, children: [(_a = (showAllTags ? tags : visibleTags)) === null || _a === void 0 ? void 0 : _a.map((tag, index) => {
                    var _a, _b;
                    const title = (_a = tag.title) !== null && _a !== void 0 ? _a : '';
                    const link = (_b = tag.link) !== null && _b !== void 0 ? _b : '';
                    return (_jsx(StyledTag, { variant: "action", as: tag.link ? "a" : "div", href: link, role: "button", id: id !== null && id !== void 0 ? id : '', tabIndex: 0, children: title }, index));
                }), hasOverflow && !showAllTags && (_jsx(StyledTag, { as: "button", variant: "action", isMoreButton: true, onClick: () => setShowAllTags(true), type: "button", children: _jsx(EllipsisIcon, {}) })), showAllTags && (_jsxs(StyledTag, { as: "button", variant: "action", isShowLessButton: true, onClick: () => setShowAllTags(false), type: "button", children: [_jsx(ChevronIcon, {}), _jsx(EllipsisIcon, {})] }))] }) }));
};
//# sourceMappingURL=Tag.js.map